import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_systemDefaultFont25t9j5zn5vlep as get_systemDefaultFont,
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem_0,
  times16x024lmmohdt as times,
  get_dp28ag147e4p5cz as get_dp,
  plus2opbwe063z9pg as plus,
  divc3x3x4wqw206 as div,
} from './data.commonHtml.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Companion_getInstance344l9hiw99vvc as Companion_getInstance,
  Companion_getInstancenv8qpb0wanrh as Companion_getInstance_0,
  applyAlpha3k2fcxahu1lgz as applyAlpha,
  FadingColor3d6ef6zcqmlhk as FadingColor,
} from './Paint.mjs';
import {
  emptyMapr06gerzljqtm as emptyMap,
  plus2m1vv33moko5t as plus_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  FontAndStyle1comk0qshc8kn as FontAndStyle,
  Dimension__hashCode_impl_p583vw27ml4nzz2xkra as Dimension__hashCode_impl_p583vw,
  divkhq3vjih9fcw as div_0,
} from './data.mjs';
import {
  Duration5ynfiptaqcrg as Duration,
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_1,
  toDuration28gf6ughsr3vf as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  RatioOfSpacing2du8cst35dyuc as RatioOfSpacing,
  PerCorner27xb33zgvi5gv as PerCorner,
  ForceConstant11m1vt5jr2l8f as ForceConstant,
  RatioOfSize1ip5bd7oxn8ba as RatioOfSize,
  Constant5dc3leeorpdb as Constant,
} from './CornerRadii.mjs';
import { Edges2jf5wl855ambv as Edges } from './Rect.mjs';
import { Companion_getInstance2k9zaro5cmj1m as Companion_getInstance_2 } from './ScreenTransitions.mjs';
import { DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Char19o2r8palgjof as Char } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_H1Semantic() {
  _init_properties_Theme_kt__w31tqv();
  return H1Semantic;
}
var H1Semantic;
function get_H2Semantic() {
  _init_properties_Theme_kt__w31tqv();
  return H2Semantic;
}
var H2Semantic;
function get_H3Semantic() {
  _init_properties_Theme_kt__w31tqv();
  return H3Semantic;
}
var H3Semantic;
function get_H4Semantic() {
  _init_properties_Theme_kt__w31tqv();
  return H4Semantic;
}
var H4Semantic;
var H5Semantic;
var H6Semantic;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.yd0_1 = [2.0, 1.6, 1.4, 1.3, 1.2, 1.1, 1.0, 0.8];
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_3() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var HeaderSizeSemanticClass;
function HeaderSizeSemantic() {
  if (HeaderSizeSemanticClass === VOID) {
    class $ extends Semantic() {
      static bd1(level) {
        Companion_getInstance_3();
        var $this = this.dd1('h' + level);
        $this.ad1_1 = level;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, VOID, theme.gb0_1.fd1(VOID, VOID, VOID, VOID, VOID, VOID, get_rem(Companion_getInstance_3().yd0_1[this.ad1_1 - 1 | 0])));
      }
      toString() {
        return 'HeaderSizeSemantic(level=' + this.ad1_1 + ')';
      }
      hashCode() {
        return this.ad1_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HeaderSizeSemantic()))
          return false;
        if (!(this.ad1_1 === other.ad1_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'HeaderSizeSemantic');
    HeaderSizeSemanticClass = $;
  }
  return HeaderSizeSemanticClass;
}
var SemanticClass;
function Semantic() {
  if (SemanticClass === VOID) {
    class $ {
      static dd1(key) {
        var $this = createThis(this);
        $this.cd1_1 = key;
        return $this;
      }
      ed1(theme) {
        return theme.cb1_1;
      }
      hd1(theme) {
        return theme.fb1(this);
      }
      id1(_this__u8e3s4, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations) {
        var tmp0_id = this.cd1_1;
        return _this__u8e3s4.nd1(tmp0_id, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations).ab1_1;
      }
      jd1(_this__u8e3s4, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations, $super) {
        cascading = cascading === VOID ? true : cascading;
        font = font === VOID ? null : font;
        elevation = elevation === VOID ? null : elevation;
        cornerRadii = cornerRadii === VOID ? null : cornerRadii;
        gap = gap === VOID ? null : gap;
        padding = padding === VOID ? null : padding;
        foreground = foreground === VOID ? null : foreground;
        iconOverride = iconOverride === VOID ? Companion_getInstance().vcy_1 : iconOverride;
        outline = outline === VOID ? null : outline;
        outlineWidth = outlineWidth === VOID ? null : outlineWidth;
        separatorOverride = separatorOverride === VOID ? Companion_getInstance().vcy_1 : separatorOverride;
        background = background === VOID ? null : background;
        blurBackground = blurBackground === VOID ? null : blurBackground;
        transform = transform === VOID ? null : transform;
        bodyTransitions = bodyTransitions === VOID ? null : bodyTransitions;
        dialogTransitions = dialogTransitions === VOID ? null : dialogTransitions;
        transitionDuration = transitionDuration === VOID ? null : transitionDuration;
        var tmp;
        if (derivations === VOID) {
          // Inline function 'kotlin.collections.mapOf' call
          tmp = emptyMap();
        } else {
          tmp = derivations;
        }
        derivations = tmp;
        var tmp_0;
        if ($super === VOID) {
          tmp_0 = this.id1(_this__u8e3s4, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations);
        } else {
          var tmp_1 = $super.id1;
          var tmp_2 = elevation;
          var tmp_3 = tmp_2 == null ? null : new (Dimension())(tmp_2);
          var tmp_4 = gap;
          var tmp_5 = tmp_4 == null ? null : new (Dimension())(tmp_4);
          var tmp_6 = outlineWidth;
          var tmp_7 = tmp_6 == null ? null : new (Dimension())(tmp_6);
          var tmp_8 = blurBackground;
          var tmp_9 = tmp_8 == null ? null : new (Dimension())(tmp_8);
          var tmp_10 = transitionDuration;
          tmp_0 = tmp_1.call(this, _this__u8e3s4, cascading, font, tmp_3, cornerRadii, tmp_5, padding, foreground, iconOverride, outline, tmp_7, separatorOverride, background, tmp_9, transform, bodyTransitions, dialogTransitions, tmp_10 == null ? null : new (Duration())(tmp_10), derivations);
        }
        return tmp_0;
      }
      kd1(_this__u8e3s4, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations) {
        var tmp0_id = this.cd1_1;
        return _this__u8e3s4.nd1(tmp0_id, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations).cb1_1;
      }
      gd1(_this__u8e3s4, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations, $super) {
        cascading = cascading === VOID ? true : cascading;
        font = font === VOID ? null : font;
        elevation = elevation === VOID ? null : elevation;
        cornerRadii = cornerRadii === VOID ? null : cornerRadii;
        gap = gap === VOID ? null : gap;
        padding = padding === VOID ? null : padding;
        foreground = foreground === VOID ? null : foreground;
        iconOverride = iconOverride === VOID ? Companion_getInstance().vcy_1 : iconOverride;
        outline = outline === VOID ? null : outline;
        outlineWidth = outlineWidth === VOID ? null : outlineWidth;
        separatorOverride = separatorOverride === VOID ? Companion_getInstance().vcy_1 : separatorOverride;
        background = background === VOID ? null : background;
        blurBackground = blurBackground === VOID ? null : blurBackground;
        transform = transform === VOID ? null : transform;
        bodyTransitions = bodyTransitions === VOID ? null : bodyTransitions;
        dialogTransitions = dialogTransitions === VOID ? null : dialogTransitions;
        transitionDuration = transitionDuration === VOID ? null : transitionDuration;
        var tmp;
        if (derivations === VOID) {
          // Inline function 'kotlin.collections.mapOf' call
          tmp = emptyMap();
        } else {
          tmp = derivations;
        }
        derivations = tmp;
        var tmp_0;
        if ($super === VOID) {
          tmp_0 = this.kd1(_this__u8e3s4, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations);
        } else {
          var tmp_1 = $super.kd1;
          var tmp_2 = elevation;
          var tmp_3 = tmp_2 == null ? null : new (Dimension())(tmp_2);
          var tmp_4 = gap;
          var tmp_5 = tmp_4 == null ? null : new (Dimension())(tmp_4);
          var tmp_6 = outlineWidth;
          var tmp_7 = tmp_6 == null ? null : new (Dimension())(tmp_6);
          var tmp_8 = blurBackground;
          var tmp_9 = tmp_8 == null ? null : new (Dimension())(tmp_8);
          var tmp_10 = transitionDuration;
          tmp_0 = tmp_1.call(this, _this__u8e3s4, cascading, font, tmp_3, cornerRadii, tmp_5, padding, foreground, iconOverride, outline, tmp_7, separatorOverride, background, tmp_9, transform, bodyTransitions, dialogTransitions, tmp_10 == null ? null : new (Duration())(tmp_10), derivations);
        }
        return tmp_0;
      }
      ld1(_this__u8e3s4, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations) {
        var tmp0_id = this.cd1_1;
        return _this__u8e3s4.nd1(tmp0_id, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations);
      }
      md1(_this__u8e3s4, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations, $super) {
        cascading = cascading === VOID ? true : cascading;
        font = font === VOID ? null : font;
        elevation = elevation === VOID ? null : elevation;
        cornerRadii = cornerRadii === VOID ? null : cornerRadii;
        gap = gap === VOID ? null : gap;
        padding = padding === VOID ? null : padding;
        foreground = foreground === VOID ? null : foreground;
        iconOverride = iconOverride === VOID ? Companion_getInstance().vcy_1 : iconOverride;
        outline = outline === VOID ? null : outline;
        outlineWidth = outlineWidth === VOID ? null : outlineWidth;
        separatorOverride = separatorOverride === VOID ? Companion_getInstance().vcy_1 : separatorOverride;
        background = background === VOID ? null : background;
        blurBackground = blurBackground === VOID ? null : blurBackground;
        transform = transform === VOID ? null : transform;
        bodyTransitions = bodyTransitions === VOID ? null : bodyTransitions;
        dialogTransitions = dialogTransitions === VOID ? null : dialogTransitions;
        transitionDuration = transitionDuration === VOID ? null : transitionDuration;
        var tmp;
        if (derivations === VOID) {
          // Inline function 'kotlin.collections.mapOf' call
          tmp = emptyMap();
        } else {
          tmp = derivations;
        }
        derivations = tmp;
        var tmp_0;
        if ($super === VOID) {
          tmp_0 = this.ld1(_this__u8e3s4, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations);
        } else {
          var tmp_1 = $super.ld1;
          var tmp_2 = elevation;
          var tmp_3 = tmp_2 == null ? null : new (Dimension())(tmp_2);
          var tmp_4 = gap;
          var tmp_5 = tmp_4 == null ? null : new (Dimension())(tmp_4);
          var tmp_6 = outlineWidth;
          var tmp_7 = tmp_6 == null ? null : new (Dimension())(tmp_6);
          var tmp_8 = blurBackground;
          var tmp_9 = tmp_8 == null ? null : new (Dimension())(tmp_8);
          var tmp_10 = transitionDuration;
          tmp_0 = tmp_1.call(this, _this__u8e3s4, cascading, font, tmp_3, cornerRadii, tmp_5, padding, foreground, iconOverride, outline, tmp_7, separatorOverride, background, tmp_9, transform, bodyTransitions, dialogTransitions, tmp_10 == null ? null : new (Duration())(tmp_10), derivations);
        }
        return tmp_0;
      }
    }
    protoOf($).abf = plus_1;
    initMetadataForClass($, 'Semantic', VOID, VOID, [ThemeDerivation()]);
    SemanticClass = $;
  }
  return SemanticClass;
}
var ThemeAndBackClass;
function ThemeAndBack() {
  if (ThemeAndBackClass === VOID) {
    class $ {
      constructor(theme, drawBackground, padding) {
        this.gb1_1 = theme;
        this.hb1_1 = drawBackground;
        this.ib1_1 = padding;
      }
      fb1(semantic) {
        return this.abf(semantic);
      }
      abf(other) {
        var b = other.hd1(this.gb1_1);
        var tmp;
        if (this.hb1_1 || b.hb1_1) {
          var tmp_0;
          if (this.ib1_1 || b.ib1_1) {
            tmp_0 = b.gb1_1.ab1_1;
          } else {
            tmp_0 = b.gb1_1.bb1_1;
          }
          tmp = tmp_0;
        } else {
          var tmp_1;
          if (this.ib1_1 || b.ib1_1) {
            tmp_1 = b.gb1_1.db1_1;
          } else {
            tmp_1 = b.gb1_1.cb1_1;
          }
          tmp = tmp_1;
        }
        return tmp;
      }
      od1(theme, drawBackground, padding) {
        return new (ThemeAndBack())(theme, drawBackground, padding);
      }
      pd1(theme, drawBackground, padding, $super) {
        theme = theme === VOID ? this.gb1_1 : theme;
        drawBackground = drawBackground === VOID ? this.hb1_1 : drawBackground;
        padding = padding === VOID ? this.ib1_1 : padding;
        return $super === VOID ? this.od1(theme, drawBackground, padding) : $super.od1.call(this, theme, drawBackground, padding);
      }
      toString() {
        return 'ThemeAndBack(theme=' + this.gb1_1.toString() + ', drawBackground=' + this.hb1_1 + ', padding=' + this.ib1_1 + ')';
      }
      hashCode() {
        var result = this.gb1_1.hashCode();
        result = imul(result, 31) + getBooleanHashCode(this.hb1_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.ib1_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ThemeAndBack()))
          return false;
        if (!this.gb1_1.equals(other.gb1_1))
          return false;
        if (!(this.hb1_1 === other.hb1_1))
          return false;
        if (!(this.ib1_1 === other.ib1_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ThemeAndBack');
    ThemeAndBackClass = $;
  }
  return ThemeAndBackClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.qd1_1 = new (Theme())('placeholder');
        this.rd1_1 = '1234567890QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnm-_';
        this.sd1_1 = 0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_4() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var ThemeClass;
function Theme() {
  if (ThemeClass === VOID) {
    class $ {
      constructor(id, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivedFrom, derivationId, revert, derivations) {
        Companion_getInstance_4();
        font = font === VOID ? new (FontAndStyle())(get_systemDefaultFont()) : font;
        elevation = elevation === VOID ? get_px(1) : elevation;
        cornerRadii = cornerRadii === VOID ? new (RatioOfSpacing())(1.0) : cornerRadii;
        gap = gap === VOID ? get_rem_0(1) : gap;
        padding = padding === VOID ? Edges().cd0(gap) : padding;
        foreground = foreground === VOID ? Companion_getInstance_0().vaz_1 : foreground;
        iconOverride = iconOverride === VOID ? null : iconOverride;
        outline = outline === VOID ? Companion_getInstance_0().vaz_1 : outline;
        outlineWidth = outlineWidth === VOID ? get_px(0) : outlineWidth;
        separatorOverride = separatorOverride === VOID ? null : separatorOverride;
        background = background === VOID ? Companion_getInstance_0().taz_1 : background;
        blurBackground = blurBackground === VOID ? get_px(0) : blurBackground;
        transform = transform === VOID ? null : transform;
        bodyTransitions = bodyTransitions === VOID ? Companion_getInstance_2().obb_1 : bodyTransitions;
        dialogTransitions = dialogTransitions === VOID ? Companion_getInstance_2().obb_1 : dialogTransitions;
        var tmp;
        if (transitionDuration === VOID) {
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance_1();
          tmp = toDuration(0.25, DurationUnit_SECONDS_getInstance());
        } else {
          tmp = transitionDuration;
        }
        transitionDuration = tmp;
        derivedFrom = derivedFrom === VOID ? null : derivedFrom;
        derivationId = derivationId === VOID ? null : derivationId;
        revert = revert === VOID ? null : revert;
        var tmp_0;
        if (derivations === VOID) {
          // Inline function 'kotlin.collections.mapOf' call
          tmp_0 = emptyMap();
        } else {
          tmp_0 = derivations;
        }
        derivations = tmp_0;
        this.fb0_1 = id;
        this.gb0_1 = font;
        this.hb0_1 = elevation;
        this.ib0_1 = cornerRadii;
        this.jb0_1 = gap;
        this.kb0_1 = padding;
        this.lb0_1 = foreground;
        this.mb0_1 = iconOverride;
        this.nb0_1 = outline;
        this.ob0_1 = outlineWidth;
        this.pb0_1 = separatorOverride;
        this.qb0_1 = background;
        this.rb0_1 = blurBackground;
        this.sb0_1 = transform;
        this.tb0_1 = bodyTransitions;
        this.ub0_1 = dialogTransitions;
        this.vb0_1 = transitionDuration;
        this.wb0_1 = derivedFrom;
        this.xb0_1 = derivationId;
        this.yb0_1 = revert;
        this.zb0_1 = derivations;
        this.ab1_1 = new (ThemeAndBack())(this, true, true);
        this.bb1_1 = new (ThemeAndBack())(this, true, false);
        this.cb1_1 = new (ThemeAndBack())(this, false, false);
        this.db1_1 = new (ThemeAndBack())(this, false, true);
        this.eb1_1 = HashMap().n8();
      }
      cb3() {
        var tmp0_elvis_lhs = this.mb0_1;
        return tmp0_elvis_lhs == null ? this.lb0_1 : tmp0_elvis_lhs;
      }
      db3() {
        var tmp0_elvis_lhs = this.pb0_1;
        return tmp0_elvis_lhs == null ? applyAlpha(this.lb0_1, 0.5) : tmp0_elvis_lhs;
      }
      fb1(semantic) {
        // Inline function 'kotlin.collections.getOrPut' call
        var this_0 = this.eb1_1;
        var value = this_0.p3(semantic);
        var tmp;
        if (value == null) {
          var tmp0_safe_receiver = this.zb0_1.p3(semantic);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(semantic, this);
          var answer = tmp1_elvis_lhs == null ? semantic.ed1(this) : tmp1_elvis_lhs;
          this_0.s3(semantic, answer);
          tmp = answer;
        } else {
          tmp = value;
        }
        return tmp;
      }
      hashCode() {
        return getStringHashCode(this.fb0_1);
      }
      equals(other) {
        var tmp;
        if (other instanceof Theme()) {
          tmp = this.fb0_1 === other.fb0_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      nd1(id, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations) {
        var tmp16_id = this.fb0_1 + '-' + id;
        var tmp17_derivedFrom = this.wb0_1;
        var tmp18_derivationId = this.xb0_1;
        var tmp19_font = font == null ? this.gb0_1 : font;
        var tmp;
        var tmp_0 = elevation;
        if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
          tmp = this.hb0_1;
        } else {
          tmp = elevation;
        }
        var tmp20_elevation = tmp;
        var tmp21_cornerRadii = cornerRadii == null ? this.ib0_1 : cornerRadii;
        var tmp_1;
        var tmp_2 = gap;
        if ((tmp_2 == null ? null : new (Dimension())(tmp_2)) == null) {
          tmp_1 = this.jb0_1;
        } else {
          tmp_1 = gap;
        }
        var tmp22_gap = tmp_1;
        var tmp23_padding = padding == null ? this.kb0_1 : padding;
        var tmp24_foreground = foreground == null ? this.lb0_1 : foreground;
        var tmp25_iconOverride = equals(iconOverride, Companion_getInstance().vcy_1) ? this.mb0_1 : iconOverride;
        var tmp26_outline = outline == null ? this.nb0_1 : outline;
        var tmp_3;
        var tmp_4 = outlineWidth;
        if ((tmp_4 == null ? null : new (Dimension())(tmp_4)) == null) {
          tmp_3 = this.ob0_1;
        } else {
          tmp_3 = outlineWidth;
        }
        var tmp27_outlineWidth = tmp_3;
        var tmp28_separatorOverride = equals(separatorOverride, Companion_getInstance().vcy_1) ? this.pb0_1 : separatorOverride;
        var tmp29_background = background == null ? this.qb0_1 : background;
        var tmp_5;
        var tmp_6 = blurBackground;
        if ((tmp_6 == null ? null : new (Dimension())(tmp_6)) == null) {
          tmp_5 = this.rb0_1;
        } else {
          tmp_5 = blurBackground;
        }
        var tmp30_blurBackground = tmp_5;
        var tmp31_transform = transform == null ? this.sb0_1 : transform;
        var tmp32_bodyTransitions = bodyTransitions == null ? this.tb0_1 : bodyTransitions;
        var tmp33_dialogTransitions = dialogTransitions == null ? this.ub0_1 : dialogTransitions;
        var tmp_7;
        var tmp_8 = transitionDuration;
        if ((tmp_8 == null ? null : new (Duration())(tmp_8)) == null) {
          tmp_7 = this.vb0_1;
        } else {
          tmp_7 = transitionDuration;
        }
        var tmp34_transitionDuration = tmp_7;
        var tmp35_derivations = plus_0(this.zb0_1, derivations);
        var tmp_9;
        if (!cascading) {
          var tmp14_elvis_lhs = this.yb0_1;
          tmp_9 = tmp14_elvis_lhs == null ? this : tmp14_elvis_lhs;
        } else {
          var tmp15_safe_receiver = this.yb0_1;
          tmp_9 = tmp15_safe_receiver == null ? null : tmp15_safe_receiver.nd1(id, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations);
        }
        var tmp36_revert = tmp_9;
        return new (Theme())(tmp16_id, tmp19_font, tmp20_elevation, tmp21_cornerRadii, tmp22_gap, tmp23_padding, tmp24_foreground, tmp25_iconOverride, tmp26_outline, tmp27_outlineWidth, tmp28_separatorOverride, tmp29_background, tmp30_blurBackground, tmp31_transform, tmp32_bodyTransitions, tmp33_dialogTransitions, tmp34_transitionDuration, tmp17_derivedFrom, tmp18_derivationId, tmp36_revert, tmp35_derivations);
      }
      td1(id, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations, $super) {
        cascading = cascading === VOID ? true : cascading;
        font = font === VOID ? null : font;
        elevation = elevation === VOID ? null : elevation;
        cornerRadii = cornerRadii === VOID ? null : cornerRadii;
        gap = gap === VOID ? null : gap;
        padding = padding === VOID ? null : padding;
        foreground = foreground === VOID ? null : foreground;
        iconOverride = iconOverride === VOID ? Companion_getInstance().vcy_1 : iconOverride;
        outline = outline === VOID ? null : outline;
        outlineWidth = outlineWidth === VOID ? null : outlineWidth;
        separatorOverride = separatorOverride === VOID ? Companion_getInstance().vcy_1 : separatorOverride;
        background = background === VOID ? null : background;
        blurBackground = blurBackground === VOID ? null : blurBackground;
        transform = transform === VOID ? null : transform;
        bodyTransitions = bodyTransitions === VOID ? null : bodyTransitions;
        dialogTransitions = dialogTransitions === VOID ? null : dialogTransitions;
        transitionDuration = transitionDuration === VOID ? null : transitionDuration;
        var tmp;
        if (derivations === VOID) {
          // Inline function 'kotlin.collections.mapOf' call
          tmp = emptyMap();
        } else {
          tmp = derivations;
        }
        derivations = tmp;
        var tmp_0;
        if ($super === VOID) {
          tmp_0 = this.nd1(id, cascading, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivations);
        } else {
          var tmp_1 = $super.nd1;
          var tmp_2 = elevation;
          var tmp_3 = tmp_2 == null ? null : new (Dimension())(tmp_2);
          var tmp_4 = gap;
          var tmp_5 = tmp_4 == null ? null : new (Dimension())(tmp_4);
          var tmp_6 = outlineWidth;
          var tmp_7 = tmp_6 == null ? null : new (Dimension())(tmp_6);
          var tmp_8 = blurBackground;
          var tmp_9 = tmp_8 == null ? null : new (Dimension())(tmp_8);
          var tmp_10 = transitionDuration;
          tmp_0 = tmp_1.call(this, id, cascading, font, tmp_3, cornerRadii, tmp_5, padding, foreground, iconOverride, outline, tmp_7, separatorOverride, background, tmp_9, transform, bodyTransitions, dialogTransitions, tmp_10 == null ? null : new (Duration())(tmp_10), derivations);
        }
        return tmp_0;
      }
      ud1(id, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, revert, derivations) {
        var tmp0_id = this.fb0_1 + '-' + id;
        var tmp1_derivedFrom = this.wb0_1;
        var tmp2_derivationId = this.xb0_1;
        var tmp3_derivations = plus_0(this.zb0_1, derivations);
        var tmp4_revert = revert ? this : null;
        return new (Theme())(tmp0_id, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, VOID, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, tmp1_derivedFrom, tmp2_derivationId, tmp4_revert, tmp3_derivations);
      }
      vd1(id, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, revert, card, field, button, hover, focus, dialog, popover, down, unselected, selected, disabled, mainContent, bar, nav, important, critical, warning, danger, affirmative) {
        // Inline function 'kotlin.collections.buildMap' call
        // Inline function 'kotlin.collections.buildMapInternal' call
        // Inline function 'kotlin.apply' call
        var this_0 = LinkedHashMap().f6();
        if (card == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it = card;
          var tmp = CardSemantic_getInstance();
          this_0.s3(tmp, ($this$put, t) => {
            var tmp0_safe_receiver = it(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (field == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_0 = field;
          var tmp_0 = FieldSemantic_getInstance();
          this_0.s3(tmp_0, ($this$put, t) => {
            var tmp0_safe_receiver = it_0(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (button == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_1 = button;
          var tmp_1 = ButtonSemantic_getInstance();
          this_0.s3(tmp_1, ($this$put, t) => {
            var tmp0_safe_receiver = it_1(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (hover == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_2 = hover;
          var tmp_2 = HoverSemantic_getInstance();
          this_0.s3(tmp_2, ($this$put, t) => {
            var tmp0_safe_receiver = it_2(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (focus == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_3 = focus;
          var tmp_3 = FocusSemantic_getInstance();
          this_0.s3(tmp_3, ($this$put, t) => {
            var tmp0_safe_receiver = it_3(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (dialog == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_4 = dialog;
          var tmp_4 = DialogSemantic_getInstance();
          this_0.s3(tmp_4, ($this$put, t) => {
            var tmp0_safe_receiver = it_4(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (popover == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_5 = popover;
          var tmp_5 = PopoverSemantic_getInstance();
          this_0.s3(tmp_5, ($this$put, t) => {
            var tmp0_safe_receiver = it_5(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (down == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_6 = down;
          var tmp_6 = DownSemantic_getInstance();
          this_0.s3(tmp_6, ($this$put, t) => {
            var tmp0_safe_receiver = it_6(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (unselected == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_7 = unselected;
          var tmp_7 = UnselectedSemantic_getInstance();
          this_0.s3(tmp_7, ($this$put, t) => {
            var tmp0_safe_receiver = it_7(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (selected == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_8 = selected;
          var tmp_8 = SelectedSemantic_getInstance();
          this_0.s3(tmp_8, ($this$put, t) => {
            var tmp0_safe_receiver = it_8(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (disabled == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_9 = disabled;
          var tmp_9 = DisabledSemantic_getInstance();
          this_0.s3(tmp_9, ($this$put, t) => {
            var tmp0_safe_receiver = it_9(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (mainContent == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_10 = mainContent;
          var tmp_10 = MainContentSemantic_getInstance();
          this_0.s3(tmp_10, ($this$put, t) => {
            var tmp0_safe_receiver = it_10(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (bar == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_11 = bar;
          var tmp_11 = BarSemantic_getInstance();
          this_0.s3(tmp_11, ($this$put, t) => {
            var tmp0_safe_receiver = it_11(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (nav == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_12 = nav;
          var tmp_12 = NavSemantic_getInstance();
          this_0.s3(tmp_12, ($this$put, t) => {
            var tmp0_safe_receiver = it_12(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (important == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_13 = important;
          var tmp_13 = ImportantSemantic_getInstance();
          this_0.s3(tmp_13, ($this$put, t) => {
            var tmp0_safe_receiver = it_13(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (critical == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_14 = critical;
          var tmp_14 = CriticalSemantic_getInstance();
          this_0.s3(tmp_14, ($this$put, t) => {
            var tmp0_safe_receiver = it_14(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (warning == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_15 = warning;
          var tmp_15 = WarningSemantic_getInstance();
          this_0.s3(tmp_15, ($this$put, t) => {
            var tmp0_safe_receiver = it_15(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (danger == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_16 = danger;
          var tmp_16 = DangerSemantic_getInstance();
          this_0.s3(tmp_16, ($this$put, t) => {
            var tmp0_safe_receiver = it_16(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        if (affirmative == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_17 = affirmative;
          var tmp_17 = AffirmativeSemantic_getInstance();
          this_0.s3(tmp_17, ($this$put, t) => {
            var tmp0_safe_receiver = it_17(t);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ab1_1;
            return tmp1_elvis_lhs == null ? t.cb1_1 : tmp1_elvis_lhs;
          });
        }
        var tmp$ret$41 = this_0.c8();
        return this.ud1(id, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, revert, plus_0(this.zb0_1, tmp$ret$41));
      }
      wd1(id, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, revert, card, field, button, hover, focus, dialog, popover, down, unselected, selected, disabled, mainContent, bar, nav, important, critical, warning, danger, affirmative, $super) {
        font = font === VOID ? this.gb0_1 : font;
        elevation = elevation === VOID ? this.hb0_1 : elevation;
        cornerRadii = cornerRadii === VOID ? this.ib0_1 : cornerRadii;
        gap = gap === VOID ? this.jb0_1 : gap;
        padding = padding === VOID ? this.kb0_1 : padding;
        foreground = foreground === VOID ? this.lb0_1 : foreground;
        iconOverride = iconOverride === VOID ? this.mb0_1 : iconOverride;
        outline = outline === VOID ? this.nb0_1 : outline;
        outlineWidth = outlineWidth === VOID ? this.ob0_1 : outlineWidth;
        background = background === VOID ? this.qb0_1 : background;
        blurBackground = blurBackground === VOID ? this.rb0_1 : blurBackground;
        transform = transform === VOID ? this.sb0_1 : transform;
        bodyTransitions = bodyTransitions === VOID ? this.tb0_1 : bodyTransitions;
        dialogTransitions = dialogTransitions === VOID ? this.ub0_1 : dialogTransitions;
        transitionDuration = transitionDuration === VOID ? this.vb0_1 : transitionDuration;
        revert = revert === VOID ? false : revert;
        card = card === VOID ? null : card;
        field = field === VOID ? null : field;
        button = button === VOID ? null : button;
        hover = hover === VOID ? null : hover;
        focus = focus === VOID ? null : focus;
        dialog = dialog === VOID ? null : dialog;
        popover = popover === VOID ? null : popover;
        down = down === VOID ? null : down;
        unselected = unselected === VOID ? null : unselected;
        selected = selected === VOID ? null : selected;
        disabled = disabled === VOID ? null : disabled;
        mainContent = mainContent === VOID ? null : mainContent;
        bar = bar === VOID ? null : bar;
        nav = nav === VOID ? null : nav;
        important = important === VOID ? null : important;
        critical = critical === VOID ? null : critical;
        warning = warning === VOID ? null : warning;
        danger = danger === VOID ? null : danger;
        affirmative = affirmative === VOID ? null : affirmative;
        return $super === VOID ? this.vd1(id, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, revert, card, field, button, hover, focus, dialog, popover, down, unselected, selected, disabled, mainContent, bar, nav, important, critical, warning, danger, affirmative) : $super.vd1.call(this, id, font, new (Dimension())(elevation), cornerRadii, new (Dimension())(gap), padding, foreground, iconOverride, outline, new (Dimension())(outlineWidth), background, new (Dimension())(blurBackground), transform, bodyTransitions, dialogTransitions, new (Duration())(transitionDuration), revert, card, field, button, hover, focus, dialog, popover, down, unselected, selected, disabled, mainContent, bar, nav, important, critical, warning, danger, affirmative);
      }
      xd1(font, title, body, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, revert) {
        // Inline function 'kotlin.run' call
        var out = 0;
        out = imul(out, 31) + font.hashCode() | 0;
        out = imul(out, 31) + Dimension__hashCode_impl_p583vw(elevation) | 0;
        out = imul(out, 31) + hashCode(cornerRadii) | 0;
        out = imul(out, 31) + Dimension__hashCode_impl_p583vw(gap) | 0;
        out = imul(out, 31) + hashCode(foreground) | 0;
        var tmp = imul(out, 31);
        // Inline function 'kotlin.hashCode' call
        var tmp1_elvis_lhs = iconOverride == null ? null : hashCode(iconOverride);
        out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
        out = imul(out, 31) + hashCode(outline) | 0;
        out = imul(out, 31) + Dimension__hashCode_impl_p583vw(outlineWidth) | 0;
        out = imul(out, 31) + hashCode(background) | 0;
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().d1();
        // Inline function 'kotlin.mod' call
        var r = (out >> 12) % 64 | 0;
        // Inline function 'kotlin.let' call
        var it = r + (64 & ((r ^ 64) & (r | (-r | 0))) >> 31) | 0;
        var tmp$ret$3 = charCodeAt(Companion_getInstance_4().rd1_1, it);
        this_0.xb(tmp$ret$3);
        // Inline function 'kotlin.mod' call
        var r_0 = (out >> 6) % 64 | 0;
        // Inline function 'kotlin.let' call
        var it_0 = r_0 + (64 & ((r_0 ^ 64) & (r_0 | (-r_0 | 0))) >> 31) | 0;
        var tmp$ret$6 = charCodeAt(Companion_getInstance_4().rd1_1, it_0);
        this_0.xb(tmp$ret$6);
        // Inline function 'kotlin.mod' call
        var r_1 = out % 64 | 0;
        // Inline function 'kotlin.let' call
        var it_1 = r_1 + (64 & ((r_1 ^ 64) & (r_1 | (-r_1 | 0))) >> 31) | 0;
        var tmp$ret$9 = charCodeAt(Companion_getInstance_4().rd1_1, it_1);
        this_0.xb(tmp$ret$9);
        var addedId = 'cp' + this_0.toString();
        // Inline function 'kotlin.collections.buildMap' call
        // Inline function 'kotlin.collections.buildMapInternal' call
        // Inline function 'kotlin.apply' call
        var this_1 = LinkedHashMap().f6();
        if (title == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var title_0 = title;
          var tmp_0 = HeaderSemantic_getInstance();
          this_1.s3(tmp_0, ($this$put, it) => it.wd1('hed', title_0).cb1_1);
        }
        var tmp$ret$20 = this_1.c8();
        return this.ud1(addedId, font, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, revert, plus_0(this.zb0_1, tmp$ret$20));
      }
      yd1(font, title, body, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, revert, $super) {
        font = font === VOID ? this.gb0_1 : font;
        title = title === VOID ? null : title;
        body = body === VOID ? null : body;
        elevation = elevation === VOID ? this.hb0_1 : elevation;
        cornerRadii = cornerRadii === VOID ? this.ib0_1 : cornerRadii;
        gap = gap === VOID ? this.jb0_1 : gap;
        padding = padding === VOID ? this.kb0_1 : padding;
        foreground = foreground === VOID ? this.lb0_1 : foreground;
        iconOverride = iconOverride === VOID ? this.mb0_1 : iconOverride;
        outline = outline === VOID ? this.nb0_1 : outline;
        outlineWidth = outlineWidth === VOID ? this.ob0_1 : outlineWidth;
        background = background === VOID ? this.qb0_1 : background;
        blurBackground = blurBackground === VOID ? this.rb0_1 : blurBackground;
        transform = transform === VOID ? this.sb0_1 : transform;
        bodyTransitions = bodyTransitions === VOID ? this.tb0_1 : bodyTransitions;
        dialogTransitions = dialogTransitions === VOID ? this.ub0_1 : dialogTransitions;
        transitionDuration = transitionDuration === VOID ? this.vb0_1 : transitionDuration;
        revert = revert === VOID ? false : revert;
        return $super === VOID ? this.xd1(font, title, body, elevation, cornerRadii, gap, padding, foreground, iconOverride, outline, outlineWidth, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, revert) : $super.xd1.call(this, font, title, body, new (Dimension())(elevation), cornerRadii, new (Dimension())(gap), padding, foreground, iconOverride, outline, new (Dimension())(outlineWidth), background, new (Dimension())(blurBackground), transform, bodyTransitions, dialogTransitions, new (Duration())(transitionDuration), revert);
      }
      toString() {
        return this.fb0_1;
      }
    }
    initMetadataForClass($, 'Theme');
    ThemeClass = $;
  }
  return ThemeClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        this.zd1_1 = None_instance;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_5() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var NoneClass;
function None() {
  if (NoneClass === VOID) {
    class $ {
      hd1(theme) {
        return theme.cb1_1;
      }
      abf(other) {
        return other;
      }
      toString() {
        return 'None';
      }
      hashCode() {
        return -1193393471;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof None()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'None', VOID, VOID, [ThemeDerivation()]);
    NoneClass = $;
  }
  return NoneClass;
}
var None_instance;
function None_getInstance() {
  return None_instance;
}
var SetClass;
function Set() {
  if (SetClass === VOID) {
    class $ {
      constructor(theme) {
        this.ad2_1 = theme;
      }
      hd1(theme) {
        return this.ad2_1.ab1_1;
      }
      toString() {
        return 'Set(theme=' + this.ad2_1.toString() + ')';
      }
      hashCode() {
        return this.ad2_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Set()))
          return false;
        if (!this.ad2_1.equals(other.ad2_1))
          return false;
        return true;
      }
    }
    protoOf($).abf = plus_1;
    initMetadataForClass($, 'Set', VOID, VOID, [ThemeDerivation()]);
    SetClass = $;
  }
  return SetClass;
}
var SetAsBaseClass;
function SetAsBase() {
  if (SetAsBaseClass === VOID) {
    class $ {
      constructor(theme) {
        this.bd2_1 = theme;
      }
      hd1(theme) {
        return this.bd2_1.bb1_1;
      }
      toString() {
        return 'SetAsBase(theme=' + this.bd2_1.toString() + ')';
      }
      hashCode() {
        return this.bd2_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetAsBase()))
          return false;
        if (!this.bd2_1.equals(other.bd2_1))
          return false;
        return true;
      }
    }
    protoOf($).abf = plus_1;
    initMetadataForClass($, 'SetAsBase', VOID, VOID, [ThemeDerivation()]);
    SetAsBaseClass = $;
  }
  return SetAsBaseClass;
}
var ChainClass;
function Chain() {
  if (ChainClass === VOID) {
    class $ {
      constructor(left, right) {
        this.cd2_1 = left;
        this.dd2_1 = right;
      }
      hd1(theme) {
        return this.cd2_1.hd1(theme).abf(this.dd2_1);
      }
      toString() {
        return 'Chain(left=' + toString(this.cd2_1) + ', right=' + toString(this.dd2_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.cd2_1);
        result = imul(result, 31) + hashCode(this.dd2_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Chain()))
          return false;
        if (!equals(this.cd2_1, other.cd2_1))
          return false;
        if (!equals(this.dd2_1, other.dd2_1))
          return false;
        return true;
      }
    }
    protoOf($).abf = plus_1;
    initMetadataForClass($, 'Chain', VOID, VOID, [ThemeDerivation()]);
    ChainClass = $;
  }
  return ChainClass;
}
function plus_1(other) {
  var tmp;
  if (other instanceof Set()) {
    tmp = other;
  } else {
    if (other instanceof SetAsBase()) {
      tmp = other;
    } else {
      tmp = new (Chain())(this, other);
    }
  }
  return tmp;
}
var ThemeDerivationClass;
function ThemeDerivation() {
  if (ThemeDerivationClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ThemeDerivation');
    ThemeDerivationClass = $;
  }
  return ThemeDerivationClass;
}
var HeaderSemanticClass;
function HeaderSemantic() {
  if (HeaderSemanticClass === VOID) {
    class $ extends Semantic() {
      static fd2() {
        HeaderSemantic_instance = null;
        var $this = this.dd1('hed');
        HeaderSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.cb1_1;
      }
      toString() {
        return 'HeaderSemantic';
      }
      hashCode() {
        return -1605536434;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HeaderSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'HeaderSemantic');
    HeaderSemanticClass = $;
  }
  return HeaderSemanticClass;
}
var HeaderSemantic_instance;
function HeaderSemantic_getInstance() {
  if (HeaderSemantic_instance === VOID)
    HeaderSemantic().fd2();
  return HeaderSemantic_instance;
}
var CardSemanticClass;
function CardSemantic() {
  if (CardSemanticClass === VOID) {
    class $ extends Semantic() {
      static hd2() {
        CardSemantic_instance = null;
        var $this = this.dd1('crd');
        CardSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.ab1_1;
      }
      toString() {
        return 'CardSemantic';
      }
      hashCode() {
        return 312972689;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CardSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'CardSemantic');
    CardSemanticClass = $;
  }
  return CardSemanticClass;
}
var CardSemantic_instance;
function CardSemantic_getInstance() {
  if (CardSemantic_instance === VOID)
    CardSemantic().hd2();
  return CardSemantic_instance;
}
var FieldSemanticClass;
function FieldSemantic() {
  if (FieldSemanticClass === VOID) {
    class $ extends Semantic() {
      static jd2() {
        FieldSemantic_instance = null;
        var $this = this.dd1('fld');
        FieldSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_outlineWidth = get_px(1);
        var base = theme.ib0_1;
        var tmp;
        if (base instanceof Constant()) {
          tmp = new (ForceConstant())(base.ray_1);
        } else {
          if (base instanceof ForceConstant()) {
            tmp = base;
          } else {
            if (base instanceof RatioOfSize()) {
              tmp = base;
            } else {
              if (base instanceof RatioOfSpacing()) {
                tmp = new (ForceConstant())(times(theme.jb0_1, base.oay_1));
              } else {
                if (base instanceof PerCorner()) {
                  tmp = base;
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
        }
        var tmp1_cornerRadii = tmp;
        return this.jd1(theme, false, VOID, VOID, tmp1_cornerRadii, VOID, VOID, VOID, VOID, VOID, tmp0_outlineWidth);
      }
      toString() {
        return 'FieldSemantic';
      }
      hashCode() {
        return 1431606181;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FieldSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'FieldSemantic');
    FieldSemanticClass = $;
  }
  return FieldSemanticClass;
}
var FieldSemantic_instance;
function FieldSemantic_getInstance() {
  if (FieldSemantic_instance === VOID)
    FieldSemantic().jd2();
  return FieldSemantic_instance;
}
var ButtonSemanticClass;
function ButtonSemantic() {
  if (ButtonSemanticClass === VOID) {
    class $ extends Semantic() {
      static ld2() {
        ButtonSemantic_instance = null;
        var $this = this.dd1('btn');
        ButtonSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.cb1_1;
      }
      toString() {
        return 'ButtonSemantic';
      }
      hashCode() {
        return 1469203699;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ButtonSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ButtonSemantic');
    ButtonSemanticClass = $;
  }
  return ButtonSemanticClass;
}
var ButtonSemantic_instance;
function ButtonSemantic_getInstance() {
  if (ButtonSemantic_instance === VOID)
    ButtonSemantic().ld2();
  return ButtonSemantic_instance;
}
function HoverSemantic$default$lambda(it) {
  return it.qcz(0.2);
}
function HoverSemantic$default$lambda_0(it) {
  return it.qcz(0.2).qcz(0.1);
}
var HoverSemanticClass;
function HoverSemantic() {
  if (HoverSemanticClass === VOID) {
    class $ extends Semantic() {
      static nd2() {
        HoverSemantic_instance = null;
        var $this = this.dd1('hov');
        HoverSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_background = theme.qb0_1.wcy(HoverSemantic$default$lambda);
        var tmp1_outline = theme.qb0_1.wcy(HoverSemantic$default$lambda_0);
        var tmp2_elevation = times(theme.hb0_1, 2.0);
        return this.jd1(theme, VOID, VOID, tmp2_elevation, VOID, VOID, VOID, VOID, VOID, tmp1_outline, VOID, VOID, tmp0_background);
      }
      toString() {
        return 'HoverSemantic';
      }
      hashCode() {
        return -1318037017;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HoverSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'HoverSemantic');
    HoverSemanticClass = $;
  }
  return HoverSemanticClass;
}
var HoverSemantic_instance;
function HoverSemantic_getInstance() {
  if (HoverSemantic_instance === VOID)
    HoverSemantic().nd2();
  return HoverSemantic_instance;
}
function FocusSemantic$default$lambda(it) {
  return it.qcz(1.0);
}
var FocusSemanticClass;
function FocusSemantic() {
  if (FocusSemanticClass === VOID) {
    class $ extends Semantic() {
      static pd2() {
        FocusSemantic_instance = null;
        var $this = this.dd1('fcs');
        FocusSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_outlineWidth = plus(theme.ob0_1, get_dp(2));
        var tmp1_outline = theme.qb0_1.wcy(FocusSemantic$default$lambda);
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_outline, tmp0_outlineWidth);
      }
      toString() {
        return 'FocusSemantic';
      }
      hashCode() {
        return -1605596797;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FocusSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'FocusSemantic');
    FocusSemanticClass = $;
  }
  return FocusSemanticClass;
}
var FocusSemantic_instance;
function FocusSemantic_getInstance() {
  if (FocusSemantic_instance === VOID)
    FocusSemantic().pd2();
  return FocusSemantic_instance;
}
var DialogSemanticClass;
function DialogSemantic() {
  if (DialogSemanticClass === VOID) {
    class $ extends Semantic() {
      static rd2() {
        DialogSemantic_instance = null;
        var $this = this.dd1('dlg');
        DialogSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.ab1_1;
      }
      toString() {
        return 'DialogSemantic';
      }
      hashCode() {
        return -1510628087;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DialogSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DialogSemantic');
    DialogSemanticClass = $;
  }
  return DialogSemanticClass;
}
var DialogSemantic_instance;
function DialogSemantic_getInstance() {
  if (DialogSemantic_instance === VOID)
    DialogSemantic().rd2();
  return DialogSemantic_instance;
}
var PopoverSemanticClass;
function PopoverSemantic() {
  if (PopoverSemanticClass === VOID) {
    class $ extends Semantic() {
      static td2() {
        PopoverSemantic_instance = null;
        var $this = this.dd1('pop');
        PopoverSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.ab1_1;
      }
      toString() {
        return 'PopoverSemantic';
      }
      hashCode() {
        return -408037104;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PopoverSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'PopoverSemantic');
    PopoverSemanticClass = $;
  }
  return PopoverSemanticClass;
}
var PopoverSemantic_instance;
function PopoverSemantic_getInstance() {
  if (PopoverSemantic_instance === VOID)
    PopoverSemantic().td2();
  return PopoverSemantic_instance;
}
function DownSemantic$default$lambda(it) {
  return it.qcz(0.3);
}
function DownSemantic$default$lambda_0(it) {
  return it.qcz(0.3).qcz(0.1);
}
var DownSemanticClass;
function DownSemantic() {
  if (DownSemanticClass === VOID) {
    class $ extends Semantic() {
      static vd2() {
        DownSemantic_instance = null;
        var $this = this.dd1('dwn');
        DownSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_background = theme.qb0_1.wcy(DownSemantic$default$lambda);
        var tmp1_outline = theme.qb0_1.wcy(DownSemantic$default$lambda_0);
        var tmp2_elevation = div(theme.hb0_1, 2.0);
        return this.jd1(theme, VOID, VOID, tmp2_elevation, VOID, VOID, VOID, VOID, VOID, tmp1_outline, VOID, VOID, tmp0_background);
      }
      toString() {
        return 'DownSemantic';
      }
      hashCode() {
        return -822702813;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DownSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DownSemantic');
    DownSemanticClass = $;
  }
  return DownSemanticClass;
}
var DownSemantic_instance;
function DownSemantic_getInstance() {
  if (DownSemantic_instance === VOID)
    DownSemantic().vd2();
  return DownSemantic_instance;
}
var UnselectedSemanticClass;
function UnselectedSemantic() {
  if (UnselectedSemanticClass === VOID) {
    class $ extends Semantic() {
      static xd2() {
        UnselectedSemantic_instance = null;
        var $this = this.dd1('uns');
        UnselectedSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_background = applyAlpha(theme.qb0_1, 0.0);
        var tmp1_outline = theme.qb0_1;
        var tmp2_outlineWidth = get_dp(2);
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_outline, tmp2_outlineWidth, VOID, tmp0_background);
      }
      toString() {
        return 'UnselectedSemantic';
      }
      hashCode() {
        return -2039615883;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UnselectedSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'UnselectedSemantic');
    UnselectedSemanticClass = $;
  }
  return UnselectedSemanticClass;
}
var UnselectedSemantic_instance;
function UnselectedSemantic_getInstance() {
  if (UnselectedSemantic_instance === VOID)
    UnselectedSemantic().xd2();
  return UnselectedSemantic_instance;
}
var SelectedSemanticClass;
function SelectedSemantic() {
  if (SelectedSemanticClass === VOID) {
    class $ extends Semantic() {
      static zd2() {
        SelectedSemantic_instance = null;
        var $this = this.dd1('sel');
        SelectedSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.fb1(DownSemantic_getInstance());
      }
      toString() {
        return 'SelectedSemantic';
      }
      hashCode() {
        return 240946332;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SelectedSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'SelectedSemantic');
    SelectedSemanticClass = $;
  }
  return SelectedSemanticClass;
}
var SelectedSemantic_instance;
function SelectedSemantic_getInstance() {
  if (SelectedSemantic_instance === VOID)
    SelectedSemantic().zd2();
  return SelectedSemantic_instance;
}
var DisabledSemanticClass;
function DisabledSemantic() {
  if (DisabledSemanticClass === VOID) {
    class $ extends Semantic() {
      static bd3() {
        DisabledSemantic_instance = null;
        var $this = this.dd1('dis');
        DisabledSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_foreground = applyAlpha(theme.lb0_1, 0.25);
        var tmp1_background = applyAlpha(theme.qb0_1, 0.5);
        var tmp2_outline = applyAlpha(theme.nb0_1, 0.25);
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_foreground, VOID, tmp2_outline, VOID, VOID, tmp1_background);
      }
      toString() {
        return 'DisabledSemantic';
      }
      hashCode() {
        return 40592253;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DisabledSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DisabledSemantic');
    DisabledSemanticClass = $;
  }
  return DisabledSemanticClass;
}
var DisabledSemantic_instance;
function DisabledSemantic_getInstance() {
  if (DisabledSemantic_instance === VOID)
    DisabledSemantic().bd3();
  return DisabledSemantic_instance;
}
var MainContentSemanticClass;
function MainContentSemantic() {
  if (MainContentSemanticClass === VOID) {
    class $ extends Semantic() {
      static dd3() {
        MainContentSemantic_instance = null;
        var $this = this.dd1('cnt');
        MainContentSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.ab1_1;
      }
      toString() {
        return 'MainContentSemantic';
      }
      hashCode() {
        return 446937451;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MainContentSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'MainContentSemantic');
    MainContentSemanticClass = $;
  }
  return MainContentSemanticClass;
}
var MainContentSemantic_instance;
function MainContentSemantic_getInstance() {
  if (MainContentSemantic_instance === VOID)
    MainContentSemantic().dd3();
  return MainContentSemantic_instance;
}
var BarSemanticClass;
function BarSemantic() {
  if (BarSemanticClass === VOID) {
    class $ extends Semantic() {
      static fd3() {
        BarSemantic_instance = null;
        var $this = this.dd1('bar');
        BarSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.fb1(ImportantSemantic_getInstance());
      }
      toString() {
        return 'BarSemantic';
      }
      hashCode() {
        return 1257583358;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BarSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'BarSemantic');
    BarSemanticClass = $;
  }
  return BarSemanticClass;
}
var BarSemantic_instance;
function BarSemantic_getInstance() {
  if (BarSemantic_instance === VOID)
    BarSemantic().fd3();
  return BarSemantic_instance;
}
var NavSemanticClass;
function NavSemantic() {
  if (NavSemanticClass === VOID) {
    class $ extends Semantic() {
      static hd3() {
        NavSemantic_instance = null;
        var $this = this.dd1('nav');
        NavSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.fb1(BarSemantic_getInstance());
      }
      toString() {
        return 'NavSemantic';
      }
      hashCode() {
        return -1765847026;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NavSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'NavSemantic');
    NavSemanticClass = $;
  }
  return NavSemanticClass;
}
var NavSemantic_instance;
function NavSemantic_getInstance() {
  if (NavSemantic_instance === VOID)
    NavSemantic().hd3();
  return NavSemantic_instance;
}
var ImportantSemanticClass;
function ImportantSemantic() {
  if (ImportantSemanticClass === VOID) {
    class $ extends Semantic() {
      static jd3() {
        ImportantSemantic_instance = null;
        var $this = this.dd1('imp');
        ImportantSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_background = theme.lb0_1;
        var tmp1_outline = theme.lb0_1;
        var tmp2_foreground = theme.qb0_1;
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_foreground, VOID, tmp1_outline, VOID, VOID, tmp0_background);
      }
      toString() {
        return 'ImportantSemantic';
      }
      hashCode() {
        return 1237157965;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ImportantSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ImportantSemantic');
    ImportantSemanticClass = $;
  }
  return ImportantSemanticClass;
}
var ImportantSemantic_instance;
function ImportantSemantic_getInstance() {
  if (ImportantSemantic_instance === VOID)
    ImportantSemantic().jd3();
  return ImportantSemantic_instance;
}
var CriticalSemanticClass;
function CriticalSemantic() {
  if (CriticalSemanticClass === VOID) {
    class $ extends Semantic() {
      static ld3() {
        CriticalSemantic_instance = null;
        var $this = this.dd1('crt');
        CriticalSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.fb1(ImportantSemantic_getInstance()).fb1(ImportantSemantic_getInstance());
      }
      toString() {
        return 'CriticalSemantic';
      }
      hashCode() {
        return -177287776;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CriticalSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'CriticalSemantic');
    CriticalSemanticClass = $;
  }
  return CriticalSemanticClass;
}
var CriticalSemantic_instance;
function CriticalSemantic_getInstance() {
  if (CriticalSemantic_instance === VOID)
    CriticalSemantic().ld3();
  return CriticalSemantic_instance;
}
var WarningSemanticClass;
function WarningSemantic() {
  if (WarningSemanticClass === VOID) {
    class $ extends Semantic() {
      static nd3() {
        WarningSemantic_instance = null;
        var $this = this.dd1('wrn');
        WarningSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_background = Companion_getInstance_0().bcz(-1872348);
        var tmp1_outline = Companion_getInstance_0().bcz(-1872348).qcz(0.1);
        var tmp2_foreground = Companion_getInstance_0().taz_1;
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_foreground, VOID, tmp1_outline, VOID, VOID, tmp0_background);
      }
      toString() {
        return 'WarningSemantic';
      }
      hashCode() {
        return 2145927943;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WarningSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'WarningSemantic');
    WarningSemanticClass = $;
  }
  return WarningSemanticClass;
}
var WarningSemantic_instance;
function WarningSemantic_getInstance() {
  if (WarningSemantic_instance === VOID)
    WarningSemantic().nd3();
  return WarningSemantic_instance;
}
var DangerSemanticClass;
function DangerSemantic() {
  if (DangerSemanticClass === VOID) {
    class $ extends Semantic() {
      static pd3() {
        DangerSemantic_instance = null;
        var $this = this.dd1('dgr');
        DangerSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_background = Companion_getInstance_0().bcz(-5242848);
        var tmp1_outline = Companion_getInstance_0().bcz(-5242848).qcz(0.1);
        var tmp2_foreground = Companion_getInstance_0().taz_1;
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_foreground, VOID, tmp1_outline, VOID, VOID, tmp0_background);
      }
      toString() {
        return 'DangerSemantic';
      }
      hashCode() {
        return -2122468636;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DangerSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DangerSemantic');
    DangerSemanticClass = $;
  }
  return DangerSemanticClass;
}
var DangerSemantic_instance;
function DangerSemantic_getInstance() {
  if (DangerSemantic_instance === VOID)
    DangerSemantic().pd3();
  return DangerSemantic_instance;
}
var AffirmativeSemanticClass;
function AffirmativeSemantic() {
  if (AffirmativeSemanticClass === VOID) {
    class $ extends Semantic() {
      static rd3() {
        AffirmativeSemantic_instance = null;
        var $this = this.dd1('afr');
        AffirmativeSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_background = Companion_getInstance_0().bcz(-14639072);
        var tmp1_outline = Companion_getInstance_0().bcz(-14639072).qcz(0.1);
        var tmp2_foreground = Companion_getInstance_0().taz_1;
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_foreground, VOID, tmp1_outline, VOID, VOID, tmp0_background);
      }
      toString() {
        return 'AffirmativeSemantic';
      }
      hashCode() {
        return -664073043;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AffirmativeSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'AffirmativeSemantic');
    AffirmativeSemanticClass = $;
  }
  return AffirmativeSemanticClass;
}
var AffirmativeSemantic_instance;
function AffirmativeSemantic_getInstance() {
  if (AffirmativeSemantic_instance === VOID)
    AffirmativeSemantic().rd3();
  return AffirmativeSemantic_instance;
}
var ListSemanticClass;
function ListSemantic() {
  if (ListSemanticClass === VOID) {
    class $ extends Semantic() {
      static td3() {
        ListSemantic_instance = null;
        var $this = this.dd1('lst');
        ListSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.cb1_1;
      }
      toString() {
        return 'ListSemantic';
      }
      hashCode() {
        return 932994335;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ListSemantic');
    ListSemanticClass = $;
  }
  return ListSemanticClass;
}
var ListSemantic_instance;
function ListSemantic_getInstance() {
  if (ListSemantic_instance === VOID)
    ListSemantic().td3();
  return ListSemantic_instance;
}
var ForcePaddingSemanticClass;
function ForcePaddingSemantic() {
  if (ForcePaddingSemanticClass === VOID) {
    class $ extends Semantic() {
      static vd3() {
        ForcePaddingSemantic_instance = null;
        var $this = this.dd1('fpad');
        ForcePaddingSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.db1_1;
      }
      toString() {
        return 'ForcePaddingSemantic';
      }
      hashCode() {
        return 1393988647;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ForcePaddingSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ForcePaddingSemantic');
    ForcePaddingSemanticClass = $;
  }
  return ForcePaddingSemanticClass;
}
var ForcePaddingSemantic_instance;
function ForcePaddingSemantic_getInstance() {
  if (ForcePaddingSemantic_instance === VOID)
    ForcePaddingSemantic().vd3();
  return ForcePaddingSemantic_instance;
}
var CompactSemanticClass;
function CompactSemantic() {
  if (CompactSemanticClass === VOID) {
    class $ extends Semantic() {
      static xd3() {
        CompactSemantic_instance = null;
        var $this = this.dd1('cmp');
        CompactSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, VOID, VOID, VOID, VOID, div_0(theme.jb0_1, 2), theme.kb0_1.gd0(2));
      }
      toString() {
        return 'CompactSemantic';
      }
      hashCode() {
        return -1662691442;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CompactSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'CompactSemantic');
    CompactSemanticClass = $;
  }
  return CompactSemanticClass;
}
var CompactSemantic_instance;
function CompactSemantic_getInstance() {
  if (CompactSemantic_instance === VOID)
    CompactSemantic().xd3();
  return CompactSemantic_instance;
}
var WorkingSemanticClass;
function WorkingSemantic() {
  if (WorkingSemanticClass === VOID) {
    class $ extends Semantic() {
      static zd3() {
        WorkingSemantic_instance = null;
        var $this = this.dd1('wrk');
        WorkingSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp = applyAlpha(theme.lb0_1, 0.5);
        var tmp0_safe_receiver = theme.mb0_1;
        return this.gd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, tmp, tmp0_safe_receiver == null ? null : applyAlpha(tmp0_safe_receiver, 0.5));
      }
      toString() {
        return 'WorkingSemantic';
      }
      hashCode() {
        return -1024173668;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WorkingSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'WorkingSemantic');
    WorkingSemanticClass = $;
  }
  return WorkingSemanticClass;
}
var WorkingSemantic_instance;
function WorkingSemantic_getInstance() {
  if (WorkingSemantic_instance === VOID)
    WorkingSemantic().zd3();
  return WorkingSemantic_instance;
}
var LoadingSemanticClass;
function LoadingSemantic() {
  if (LoadingSemanticClass === VOID) {
    class $ extends Semantic() {
      static bd4() {
        LoadingSemantic_instance = null;
        var $this = this.dd1('ld');
        LoadingSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp1_background = new (FadingColor())(theme.qb0_1.db2().qcz(0.1), theme.qb0_1.db2().qcz(0.2));
        var tmp2_outline = new (FadingColor())(theme.nb0_1.db2().qcz(0.1), theme.nb0_1.db2().qcz(0.2));
        var tmp3_foreground = applyAlpha(theme.lb0_1, 0.3);
        var tmp0_safe_receiver = theme.mb0_1;
        var tmp4_iconOverride = tmp0_safe_receiver == null ? null : applyAlpha(tmp0_safe_receiver, 0.3);
        return this.md1(theme, VOID, VOID, VOID, VOID, VOID, VOID, tmp3_foreground, tmp4_iconOverride, tmp2_outline, VOID, VOID, tmp1_background).bb1_1;
      }
      toString() {
        return 'LoadingSemantic';
      }
      hashCode() {
        return -638069593;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LoadingSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'LoadingSemantic');
    LoadingSemanticClass = $;
  }
  return LoadingSemanticClass;
}
var LoadingSemantic_instance;
function LoadingSemantic_getInstance() {
  if (LoadingSemantic_instance === VOID)
    LoadingSemantic().bd4();
  return LoadingSemantic_instance;
}
var ClickableSemanticClass;
function ClickableSemantic() {
  if (ClickableSemanticClass === VOID) {
    class $ extends Semantic() {
      static dd4() {
        ClickableSemantic_instance = null;
        var $this = this.dd1('clk');
        ClickableSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.db1_1;
      }
      toString() {
        return 'ClickableSemantic';
      }
      hashCode() {
        return 1565914893;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClickableSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ClickableSemantic');
    ClickableSemanticClass = $;
  }
  return ClickableSemanticClass;
}
var ClickableSemantic_instance;
function ClickableSemantic_getInstance() {
  if (ClickableSemantic_instance === VOID)
    ClickableSemantic().dd4();
  return ClickableSemantic_instance;
}
var SubtextSemanticClass;
function SubtextSemantic() {
  if (SubtextSemanticClass === VOID) {
    class $ extends Semantic() {
      static fd4() {
        SubtextSemantic_instance = null;
        var $this = this.dd1('sub');
        SubtextSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, VOID, theme.gb0_1.fd1(VOID, VOID, VOID, VOID, VOID, VOID, get_rem(0.8)), VOID, VOID, VOID, VOID, applyAlpha(theme.lb0_1, 0.7));
      }
      toString() {
        return 'SubtextSemantic';
      }
      hashCode() {
        return -1030941224;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SubtextSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'SubtextSemantic');
    SubtextSemanticClass = $;
  }
  return SubtextSemanticClass;
}
var SubtextSemantic_instance;
function SubtextSemantic_getInstance() {
  if (SubtextSemantic_instance === VOID)
    SubtextSemantic().fd4();
  return SubtextSemantic_instance;
}
var PrintSemanticClass;
function PrintSemantic() {
  if (PrintSemanticClass === VOID) {
    class $ extends Semantic() {
      static hd4() {
        PrintSemantic_instance = null;
        var $this = this.dd1('print');
        PrintSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_background = Companion_getInstance_0().taz_1;
        var tmp1_foreground = Companion_getInstance_0().vaz_1;
        var tmp2_outline = theme.qb0_1;
        var tmp3_outlineWidth = get_px(2);
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_foreground, VOID, tmp2_outline, tmp3_outlineWidth, VOID, tmp0_background);
      }
      toString() {
        return 'PrintSemantic';
      }
      hashCode() {
        return 1813922392;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PrintSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'PrintSemantic');
    PrintSemanticClass = $;
  }
  return PrintSemanticClass;
}
var PrintSemantic_instance;
function PrintSemantic_getInstance() {
  if (PrintSemantic_instance === VOID)
    PrintSemantic().hd4();
  return PrintSemantic_instance;
}
var DismissSemanticClass;
function DismissSemantic() {
  if (DismissSemanticClass === VOID) {
    class $ extends Semantic() {
      static jd4() {
        DismissSemantic_instance = null;
        var $this = this.dd1('dsmss');
        DismissSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_gap = get_dp(0);
        var tmp1_cornerRadii = new (Constant())(get_dp(0));
        var tmp2_background = Companion_getInstance_0().vaz_1.ecz(0.5);
        return this.jd1(theme, false, VOID, VOID, tmp1_cornerRadii, tmp0_gap, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_background);
      }
      toString() {
        return 'DismissSemantic';
      }
      hashCode() {
        return -2096924683;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DismissSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DismissSemantic');
    DismissSemanticClass = $;
  }
  return DismissSemanticClass;
}
var DismissSemantic_instance;
function DismissSemantic_getInstance() {
  if (DismissSemantic_instance === VOID)
    DismissSemantic().jd4();
  return DismissSemantic_instance;
}
var InvalidSemanticClass;
function InvalidSemantic() {
  if (InvalidSemanticClass === VOID) {
    class $ extends Semantic() {
      static ld4() {
        InvalidSemantic_instance = null;
        var $this = this.dd1('ivd');
        InvalidSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_outlineWidth = get_px(1);
        var tmp1_outline = Companion_getInstance_0().waz_1;
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_outline, tmp0_outlineWidth);
      }
      toString() {
        return 'InvalidSemantic';
      }
      hashCode() {
        return -1599866270;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof InvalidSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'InvalidSemantic');
    InvalidSemanticClass = $;
  }
  return InvalidSemanticClass;
}
var InvalidSemantic_instance;
function InvalidSemantic_getInstance() {
  if (InvalidSemantic_instance === VOID)
    InvalidSemantic().ld4();
  return InvalidSemantic_instance;
}
var EmphasizedSemanticClass;
function EmphasizedSemantic() {
  if (EmphasizedSemanticClass === VOID) {
    class $ extends Semantic() {
      static nd4() {
        EmphasizedSemantic_instance = null;
        var $this = this.dd1('emf');
        EmphasizedSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, VOID, theme.gb0_1.fd1(VOID, true));
      }
      toString() {
        return 'EmphasizedSemantic';
      }
      hashCode() {
        return 1470846371;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EmphasizedSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'EmphasizedSemantic');
    EmphasizedSemanticClass = $;
  }
  return EmphasizedSemanticClass;
}
var EmphasizedSemantic_instance;
function EmphasizedSemantic_getInstance() {
  if (EmphasizedSemantic_instance === VOID)
    EmphasizedSemantic().nd4();
  return EmphasizedSemantic_instance;
}
var InsetSemanticClass;
function InsetSemantic() {
  if (InsetSemanticClass === VOID) {
    class $ extends Semantic() {
      static pd4() {
        InsetSemantic_instance = null;
        var $this = this.dd1('inset');
        InsetSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.ab1_1;
      }
      toString() {
        return 'InsetSemantic';
      }
      hashCode() {
        return 35422408;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof InsetSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'InsetSemantic');
    InsetSemanticClass = $;
  }
  return InsetSemanticClass;
}
var InsetSemantic_instance;
function InsetSemantic_getInstance() {
  if (InsetSemantic_instance === VOID)
    InsetSemantic().pd4();
  return InsetSemantic_instance;
}
var ErrorSemanticClass;
function ErrorSemantic() {
  if (ErrorSemanticClass === VOID) {
    class $ extends Semantic() {
      static rd4() {
        ErrorSemantic_instance = null;
        var $this = this.dd1('err');
        ErrorSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, theme.fb1(DangerSemantic_getInstance()).gb1_1.qb0_1.db2().qcz(0.2));
      }
      toString() {
        return 'ErrorSemantic';
      }
      hashCode() {
        return 877123251;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ErrorSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ErrorSemantic');
    ErrorSemanticClass = $;
  }
  return ErrorSemanticClass;
}
var ErrorSemantic_instance;
function ErrorSemantic_getInstance() {
  if (ErrorSemantic_instance === VOID)
    ErrorSemantic().rd4();
  return ErrorSemantic_instance;
}
var FieldLabelSemanticClass;
function FieldLabelSemantic() {
  if (FieldLabelSemanticClass === VOID) {
    class $ extends Semantic() {
      static td4() {
        FieldLabelSemantic_instance = null;
        var $this = this.dd1('flabel');
        FieldLabelSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.fb1(SubtextSemantic_getInstance());
      }
      toString() {
        return 'FieldLabelSemantic';
      }
      hashCode() {
        return 1317522011;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FieldLabelSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'FieldLabelSemantic');
    FieldLabelSemanticClass = $;
  }
  return FieldLabelSemanticClass;
}
var FieldLabelSemantic_instance;
function FieldLabelSemantic_getInstance() {
  if (FieldLabelSemantic_instance === VOID)
    FieldLabelSemantic().td4();
  return FieldLabelSemantic_instance;
}
var properties_initialized_Theme_kt_uwj6hl;
function _init_properties_Theme_kt__w31tqv() {
  if (!properties_initialized_Theme_kt_uwj6hl) {
    properties_initialized_Theme_kt_uwj6hl = true;
    H1Semantic = HeaderSizeSemantic().bd1(1);
    H2Semantic = HeaderSizeSemantic().bd1(2);
    H3Semantic = HeaderSizeSemantic().bd1(3);
    H4Semantic = HeaderSizeSemantic().bd1(4);
    H5Semantic = HeaderSizeSemantic().bd1(5);
    H6Semantic = HeaderSizeSemantic().bd1(6);
  }
}
//region block: init
None_instance = new (None())();
//endregion
//region block: exports
export {
  get_H1Semantic as get_H1Semantic28sytsa4fm6nk,
  get_H2Semantic as get_H2Semantic1i9pxrezr3hyb,
  get_H3Semantic as get_H3Semantic2xvwj5aimpbn,
  get_H4Semantic as get_H4Semantic111wmmqwoslob,
  Semantic as Semanticpmpmvt7fldq2,
  SetAsBase as SetAsBase1p1kkt5i4f45k,
  Set as Set2awzlbbrsme5i,
  plus_1 as plus354lvypr4cqa1,
  ThemeDerivation as ThemeDerivation3kcl449hwgd5y,
  Theme as Themeex1jjdf3pz9y,
  AffirmativeSemantic_getInstance as AffirmativeSemantic_getInstance3qy0l8mucaq7h,
  BarSemantic_getInstance as BarSemantic_getInstance5oimrhs7x11g,
  ButtonSemantic_getInstance as ButtonSemantic_getInstance2exl8jbak13ac,
  CardSemantic_getInstance as CardSemantic_getInstance24h7hf3qltxfl,
  ClickableSemantic_getInstance as ClickableSemantic_getInstance2dwzbc0ganf8f,
  CompactSemantic_getInstance as CompactSemantic_getInstance287c07xso9hna,
  DangerSemantic_getInstance as DangerSemantic_getInstance3i0xmw7we3iku,
  DialogSemantic_getInstance as DialogSemantic_getInstance3cqn6ufjbbrs2,
  DisabledSemantic_getInstance as DisabledSemantic_getInstanceimdypc22j9b3,
  DismissSemantic_getInstance as DismissSemantic_getInstancerntwsmxwx5kd,
  DownSemantic_getInstance as DownSemantic_getInstance12o2om5g6786l,
  EmphasizedSemantic_getInstance as EmphasizedSemantic_getInstancev1hnk3pae9tz,
  ErrorSemantic_getInstance as ErrorSemantic_getInstanceqmizdq1y2zzq,
  FieldLabelSemantic_getInstance as FieldLabelSemantic_getInstance23isvm7e8qjx6,
  FieldSemantic_getInstance as FieldSemantic_getInstance2sngfoinp7a00,
  FocusSemantic_getInstance as FocusSemantic_getInstance2hulmpskh8zvf,
  ForcePaddingSemantic_getInstance as ForcePaddingSemantic_getInstance2mi5o79ljh5pc,
  HeaderSemantic_getInstance as HeaderSemantic_getInstance39z1p9hszg7wp,
  HoverSemantic_getInstance as HoverSemantic_getInstance2nvjr5vpt4xe8,
  ImportantSemantic_getInstance as ImportantSemantic_getInstance19jf9bmkjsdl8,
  InsetSemantic_getInstance as InsetSemantic_getInstance3sydcrxjokdsg,
  InvalidSemantic_getInstance as InvalidSemantic_getInstance19jq406epp0mv,
  ListSemantic_getInstance as ListSemantic_getInstance1hx6c2zatma42,
  LoadingSemantic_getInstance as LoadingSemantic_getInstance2bll1ncm1bbe7,
  NavSemantic_getInstance as NavSemantic_getInstance3ooa6be5xy9hs,
  PopoverSemantic_getInstance as PopoverSemantic_getInstance1gd43d9y00yoy,
  PrintSemantic_getInstance as PrintSemantic_getInstance88ipr19ayg2g,
  SelectedSemantic_getInstance as SelectedSemantic_getInstance3ef29ujazc52t,
  SubtextSemantic_getInstance as SubtextSemantic_getInstance3oi0npjp97gok,
  Companion_getInstance_4 as Companion_getInstance31w1ky5wvnamo,
  Companion_getInstance_5 as Companion_getInstance1350ksylxva5s,
  UnselectedSemantic_getInstance as UnselectedSemantic_getInstancexnnq5hq6ryv2,
  WarningSemantic_getInstance as WarningSemantic_getInstance2xxn62yaantj2,
  WorkingSemantic_getInstance as WorkingSemantic_getInstance38e4ialv1t20v,
};
//endregion

//# sourceMappingURL=Theme.mjs.map
